import axios from "axios";

export class LoginService {
    singUp(username, password) {
        let formData = {
            'userName': username,
            'password': password
        };
        return axios.post('/appapv/signIn.action', formData, {
            credentials: 'same-origin',
            params: {}
        }).then(res => res.data);
    }

    singUpMFA(username, token) {
        let formData = {
            'userName': username,
            'token': token
        };
        return axios.post('/appapv/signInMfa.action', formData, {
            credentials: 'same-origin',
            params: {}
        }).then(res => res.data);
    }
}